module.exports = __webpack_public_path__ + "static/media/0223_IMG_LE_SOL_LEGNI_WALNUT.cb3526ab.png";